<template>
  <div>
    <el-table
      :data="tableData"
      stripe
      v-on="$listeners"
      v-bind="$attrs"
      row-key="accidentId"
      v-loading="loading"
      @selection-change="$emit('update:selectedAccidents', $event)"

    >
      <el-table-column
        type="selection"
        align="center"
        v-if="selectedAccidents"
      />
      <div>
        <!-- <el-table-column class-name="orderNumber" type="index" label="序号"></el-table-column> -->
        <div v-for="(item, index) in formValues" :key="index">
          <el-table-column :label="item" :prop="formKeys[index]"></el-table-column>
        </div>
      </div>

      <!-- <el-table-column label="事故编号" prop="accidentId"></el-table-column>
      <el-table-column label="报警电话" prop="reportPhone"></el-table-column>
      <el-table-column
        label="事故地点"
        min-width="200px"
        prop="accidentAddress"
      ></el-table-column>
      <el-table-column label="接听坐席" prop="answerAgent"></el-table-column>
      <el-table-column
        prop="caseDealType"
        :formatter="({ caseDealType }) => dictMap.case_deal_type[caseDealType]"
      >
      </el-table-column>
      <el-table-column label="定责" prop="liability">
        <template #default="{ row: { liability } }" }>
          <span v-if="liability">
            <el-icon name="success" class="text-success"></el-icon>
            已定责
          </span>
          <span v-else>
            <el-icon name="remove" class="text-danger"></el-icon>
            未定责
          </span>
        </template>
      </el-table-column>
      <el-table-column label="理赔" prop="claim">
        <template #default="{ row: { claim } }" }>
          <span v-if="claim">
            <el-icon name="success" class="text-success"></el-icon>
            已理赔
          </span>
          <span v-else>
            <el-icon name="remove" class="text-danger"></el-icon>
            未理赔
          </span>
        </template>
      </el-table-column>
      <el-table-column label="事故认定书" prop="upload">
        <template #default="{ row: { upload } }" }>
          <span v-if="upload">
            <el-icon name="success" class="text-success"></el-icon>
            已上传
          </span>
          <span v-else>
            <el-icon name="remove" class="text-danger"></el-icon>
            未上传
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="事故状态"
        prop="status"
        :formatter="({ status }) => dictMap.accident_status[status]"
      >
      </el-table-column> -->
      <el-table-column label="操作" width="150px">
        <div
          class="operator-group"
          slot-scope="{
            row: { accidentId, liability, claim, status, upload, statementUrl, accidentPartyList, caseDealType }
          }"
        >
          <el-link
            @click="
              $router.push({
                name: 'AccidentEdit',
                params: { id: accidentId }
              })
            "
            >查看</el-link
          >

          <template v-if="status === 1 && caseDealType !== 1">
            <el-link
              type="primary"
              v-if="!liability && (currentRole === '交警' || isAdmin || (currentRole === '坐席' && !accidentPartyList.find(el=>{
                el.role_ids.includes('101')
              })))"
              @click="
                () => {
                  currentAccidentId = accidentId;
                  liabilityVisible = true;
                }
              "
              >定责
            </el-link>

            <el-link
              type="primary"
              v-if="!claim && currentRole === '保险员'"
              @click="
                () => {
                  currentAccidentId = accidentId;
                  claimVisible = true;
                }
              "
              >理赔
            </el-link>
          </template>
          <el-link
            type="primary"
            v-if="!upload && currentRole === '坐席'"
            @click="
              () => {
                currentAccidentId = accidentId;
                currentStatementUrl = statementUrl;
                uploadVisible = true;
              }
            "
          >
            上传
          </el-link>
        </div>
      </el-table-column>
    </el-table>
    <pagination
      :total="pagination.total"
      :page.sync="pagination.page"
      :limit.sync="pagination.size"
      @pagination="$emit('pagination')"
    />
    <liability
      :accidentId="currentAccidentId"
      :visible.sync="liabilityVisible"
      @ok="$emit('refresh')"
    />
    <claim
      :accidentId="currentAccidentId"
      :visible.sync="claimVisible"
      @ok="$emit('refresh')"
    />
    <el-dialog
      :visible.sync="uploadVisible"
      center
      title="上传事故认定书"
      destroy-on-close
    >
      <upload-statement
        :accidentId="currentAccidentId"
        :statementUrl.sync="currentStatementUrl"
      />
      <template #footer>
        <el-button
          @click="
            () => {
              uploadVisible = false;
              $emit('getUserInfoToShow');
            }
          "
          type="primary"
          >确定</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import Liability from "@/views/accident/components/Liability";
import Claim from "@/views/accident/components/Claim";
import UploadStatement from "@/views/accident/components/UploadStatement.vue";
import { commonAccidentList } from '@/views/accidentList.js'

export default {
  components: { Liability, Claim, UploadStatement },
  props: {
    source: {
      type: Object,
      default: () => commonAccidentList
    },
    tableData: {
      type: Array,
      default: () => []
    },
    selectedAccidents: {
      type: Array,
      required: false
    },
    pagination: {
      type: Object,
      default: () => ({
        page: 1,
        size: 10,
        total: 0
      })
    },
    loading: { type: Boolean, default: false }
  },
  computed: {
    currentRole() {
      console.info("我的角色", this.$store.getters.accidentRoleName)
      return this.$store.getters.accidentRoleName;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    }
  },
  data() {
    return {
      currentAccidentId: "",
      liabilityVisible: false,
      claimVisible: false,
      uploadVisible: false,
      currentStatementUrl: "",
      dictMap: { accident_status: {}, case_deal_type: {} },
      formKeys: [],
      formValues: []
    };
  },
  methods: {
    getNeedDicts() {
      this.getDicts(Object.keys(this.dictMap)).then(data => {
        this.dictMap = Object.keys(this.dictMap).reduce((acc, dictType) => {
          acc[dictType] = data[dictType].reduce(
            (map, { dictLabel, dictValue }) => {
              map[dictValue] = dictLabel;
              return map;
            },
            {}
          );
          return acc;
        }, {});
      });
    },
    getFormTitle() {
      this.formKeys = Object.keys(this.source)
      this.formValues = Object.values(this.source)
    }
  },
  created() {
    this.getNeedDicts();
    this.getFormTitle();
    console.log(this.formKeys, this.formValues);
  }
};
</script>
<style lang="less">
.operator-group {
  & > *:not(:last-child) {
    margin-right: 10px;
  }
}
.orderNumber {
  // float: right;
}
</style>
